import React, { useEffect, useState } from "react";
import { Container, Box, LinearProgress} from "@mui/material";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import apiClient from "../api/apiClient";
import { uD } from '../context/DC';
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const P08011 = () => {  
  const token = localStorage.getItem("token");
  const { mG } = uD();
  const [pg, sP] = useState(0); 
  const [ld, sL] = useState(false); 
  const [d, sD] = useState([]);
  const [s, sS] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [error, setError] = useState(false);
  const cs = startDate && dayjs(startDate).isValid() && !ld;

  const fD = async (uSD = false) => {
    sL(true);   
    sP(0); 
    sD([]); 
    try {   
       
      let preDate;
      if (uSD) {
        if (!startDate || !dayjs(startDate).isValid()) {
          setError(true);
          return;
        }
        preDate = dayjs(startDate).format("YYYY-MM-DD");
      } else {
        preDate = dayjs().subtract(1, 'day').format("YYYY-MM-DD");
      }

      const d = {
        screen: "08011",
        startdate: preDate
        };   
        
      const r = await apiClient.get("/api-data/08011", {headers: { Authorization: `Bearer ${token}` },params: d });
      if (r.data.s=='0' && r.data.d.rowCount > 0) {
        sD(r.data.d.rows);
        sS(false);
      } else if (r.data.s=='0' && r.data.d.rowCount == 0) {
        if (uSD) {
          await mG({t: "Warning",tc: "#ffa000",m: "ไม่พบข้อมูล กรุณาค้นหาข้อมูลใหม่อีกครั้ง",bt: "OK",btc: "white",bc: "#ffb300",bch: "#ff6f00",}); 
        }
      } else {
        await mG({t: "Failed",tc: "#e40000",m: r.data.m+r.data.e,bt: "Close",btc: "white",bc: "#ff1616",bch: "#d40000",}); 
      }   
      
    } catch (error) {
      let errMsg = "";
      if (error?.response?.data) {errMsg = error.response.data.error ||error.response.data.message ||JSON.stringify(error.response.data);
      } else if (error?.message) {errMsg = error.message;}
      await mG({t: "Failed",tc: "#e40000",m: errMsg || "Please contact aiscimer team.",bt: "Close",btc: "white",bc: "#ff1616",bch: "#d40000",}); 
    } finally {
      sL(false);
      sP(100);
    }
  };

  useEffect(() => {
    fD(false);
  }, []);


  const handleExportExcel = async () => {
    if (!d.length) {
      await mG({t: "Warning",tc: "#ffa000",m: "ไม่มีข้อมูลสำหรับ Export",bt: "OK",btc: "white",bc: "#ffb300",bch: "#ff6f00",}); 
      return;
    }
  
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("FAP_AllBankBalance");

    worksheet.columns = [
      { header: "ลำดับ", key: "index", width: 10 },
      { header: "ธนาคาร", key: "a3", width: 15 },
      { header: "ประเภท", key: "a4", width: 15 },
      { header: "เลขที่บัญชี", key: "a5", width: 15 },

      { header: "วันที่ดูรายงาน", key: "a12", width: 15 },
      { header: "วันที่ข้อมูลธนาคาร", key: "a1", width: 15 },

      { header: "เงินหักบัญชี", key: "a6", width: 15 },
      { header: "เงินนำฝากเข้าบัญชี", key: "a7", width: 15 },
      { header: "ยอดคงเหลือ", key: "a8", width: 15 },
      { header: "วงเงิน OD", key: "a9", width: 15 },
      { header: "ยอดเงินคงเหลือที่ใช้ได้", key: "a10", width: 15 },
     
    ];
  
    d.forEach((file, index) => {
      const row = worksheet.addRow({

        index: index + 1,
        a3: file.a3,
        a4: file.a4,
        a5: file.a5,
       
        a12: file.a12 ? new Date(file.a12).toISOString().split("T")[0] : "",
        a1: file.a1 ? new Date(file.a1).toISOString().split("T")[0] : "",

        a6: new Intl.NumberFormat('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(file.a6),
        a7: new Intl.NumberFormat('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(file.a7),
        a8: new Intl.NumberFormat('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(file.a8),
        a9: new Intl.NumberFormat('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(file.a9),
        a10: new Intl.NumberFormat('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(file.a10),
       
      });
  
    });
  
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    saveAs(blob, "FAP_AllBankBalance_Report.xlsx");
  };

  return (
    <Container component="main" maxWidth="96%" sx={{marginTop: "40px",border: "0px solid #e0e0e0",boxSizing: "border-box",}}>

      {ld ? (
        <Box sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.3)",
          zIndex: 999,
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}>
          <LinearProgress variant="determinate" value={pg} sx={{ width: '50%' }} />
        </Box>

       ) : ( 

      <Box sx={{ width: '100%',display: "flex",flexDirection: "column", marginLeft:0, marginBottom:0, boxShadow: "none",marginTop: "0px",border: "0px solid #e0e0e0" ,boxSizing: "border-box",
        backgroundColor: "background.paper",
      }}>

        <Box sx={{ borderRadius: 0,boxSizing: "border-box",marginBottom:"4px", boxShadow: "none",marginTop: "0px",
          textAlign: "center",
          verticalAlign: "middle",
          padding:1,
          backgroundColor: "#f5f5f5",
          fontSize: "calc(14px + 0.5vw)",
          fontWeight: "bold",
          color: "#333",
          width: '100%'
        }}>
          รายงานยอดเงินสดคงเหลือทุกบัญชีธนาคาร (All Bank Balance)
        </Box>

        <Box sx={{  marginBottom:"4px", boxShadow: "none",marginTop: "4px",border: "1px solid #e0e0e0" ,boxSizing: "border-box",
                        borderRadius: 0,textAlign: "center",verticalAlign: "middle",fontSize: "calc(14px - 0.01vw)",padding:1,
                        display: "flex",       
                        justifyContent: "center",  
                        alignItems: "center",
                        gap: 2, flexWrap: "wrap",
                      }}>
               
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker label="เลือกวันที่*"
                              value={startDate}
                              onChange={(newValue) => {
                                setStartDate(newValue);
                                setError(false);
                                sD([]); 
                              }}
                              sx={{ width: 190 }}
                              slotProps={{
                                field: { clearable: true, onClear: () => setStartDate(null) },
                                textField: { 
                                  size: 'small',
                                  placeholder: 'Select Date',
                                  error: error,
                                  helperText: error && !startDate ? 'กรุณาเลือกวัน' : '',
                                },
                              }}
                              
                            />
              </LocalizationProvider>

                <button
                  onClick={() => {
                    if (!startDate || !dayjs(startDate).isValid()) {
                      setError(true);
                      return;
                    }
                    fD(true);
                  }}
                  disabled={!cs}
                  style={{
                    padding: "8px 15px",
                    background: "#0061d4",
                    color: "white",
                    border: "none",
                    cursor: !cs ? "not-allowed" : "pointer",
                    fontSize: "calc(8px + 0.5vw)",
                    marginRight: "10px",
                    opacity: !cs ? 0.6 : 1,
                  }}
                >
                  แสดงข้อมูล
              </button>
  

          </Box>

        {d.length <= 0 && (
        <Box sx={{  marginBottom:"4px", boxShadow: "none",marginTop: "0px",border: "1px solid #e0e0e0" ,boxSizing: "border-box",
          borderRadius: 0,textAlign: "center",verticalAlign: "middle",fontSize: "calc(14px - 0.01vw)",padding:1,
        }}>
              "กรุณาเลือกวันที่แล้วคลิกแสดงข้อมูล"
        </Box>
        )}
        
        {d.length > 0 && (

          <>

          <TableContainer
            component={Paper}
            sx={{
              maxHeight: 400,
              overflow: "auto",
              minWidth: 800,    
            }}
          >
            <Table size="small" aria-label="a dense table" sx={{ borderCollapse: 'collapse' }}>
            <TableHead sx={{ backgroundColor: '#f5f5f5',whiteSpace: "nowrap", }}>
                <TableRow>

                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)'}}>#</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>ธนาคาร</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>ประเภท</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>เลขที่บัญชี</TableCell> 
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>วันที่ดูรายงาน</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>วันที่ข้อมูลธนาคาร</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>เงินหักบัญชี</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>เงินนำฝากเข้าบัญชี</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>ยอดคงเหลือ</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>วงเงิน OD</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>ยอดเงินคงเหลือที่ใช้ได้</TableCell>
                
                </TableRow>
              </TableHead>


              <TableBody>
                {d.map((file, index) => (
                  <TableRow
                    key={index+1}
                  >

                    <TableCell align="center" component="th" scope="row" sx={{ border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                      {index+1}
                    </TableCell>

                    <TableCell align="left" sx={{whiteSpace: "nowrap", border: '1px solid rgba(0, 0, 0, 0.3)' }} >{file.a3}</TableCell>
                    <TableCell align="left" sx={{whiteSpace: "nowrap", border: '1px solid rgba(0, 0, 0, 0.3)' }} >{file.a4}</TableCell>
                    <TableCell align="left" sx={{whiteSpace: "nowrap", border: '1px solid rgba(0, 0, 0, 0.3)' }} >{file.a5}</TableCell>
                     
                    <TableCell align="center" sx={{ whiteSpace: "nowrap", border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                      {file.a12 ? new Date(file.a12).toISOString().split("T")[0] : ""}
                    </TableCell>

                    <TableCell align="center" sx={{ whiteSpace: "nowrap", border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                      {file.a1 ? new Date(file.a1).toISOString().split("T")[0] : ""}
                    </TableCell>
                    
                    <TableCell align="right" sx={{whiteSpace: "nowrap", border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                      {new Intl.NumberFormat('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(file.a6)}
                    </TableCell>
                    <TableCell align="right" sx={{whiteSpace: "nowrap", border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                        {new Intl.NumberFormat('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(file.a7)}
                    </TableCell>
                    <TableCell align="right" sx={{whiteSpace: "nowrap", border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                        {new Intl.NumberFormat('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(file.a8)}
                    </TableCell>
                    <TableCell align="right" sx={{whiteSpace: "nowrap", border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                        {new Intl.NumberFormat('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(file.a9)}
                    </TableCell>
                    <TableCell align="right" sx={{whiteSpace: "nowrap", border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                        {new Intl.NumberFormat('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(file.a10)}
                    </TableCell>



                  </TableRow>
                ))}
              </TableBody>


            </Table>
          </TableContainer>

          </>
        )}
        
        {d.length > 0 && (
          <Box sx={{  marginBottom:0, boxShadow: "none",marginTop: "4px" ,boxSizing: "border-box",
            borderRadius: 0,
            padding: "4px 4px",
            textAlign: "center",
            verticalAlign: "middle",
          }}>

            <button
              onClick={handleExportExcel}
              style={{
                padding: "8px 15px",
                background: "#0061d4",
                color: "white",
                border: "none",
                cursor: "pointer",
                fontSize: "calc(8px + 0.5vw)",
              }}
            >
              Export Excel
            </button>
          </Box>
        )}

      </Box>

      )}

    </Container>
  );
};

export default P08011;